import { render } from "./MdMenu.vue?vue&type=template&id=b00df50c&scoped=true&ts=true"
import script from "./MdMenu.vue?vue&type=script&lang=ts"
export * from "./MdMenu.vue?vue&type=script&lang=ts"

import "./MdMenu.vue?vue&type=style&index=0&id=b00df50c&lang=scss&scoped=true"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b00df50c"]])

export default __exports__